import { render, staticRenderFns } from "./appScoringApplication.vue?vue&type=template&id=68c7372d&scoped=true"
import script from "./appScoringApplication.vue?vue&type=script&lang=js"
export * from "./appScoringApplication.vue?vue&type=script&lang=js"
import style0 from "./appScoringApplication.vue?vue&type=style&index=0&id=68c7372d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c7372d",
  null
  
)

export default component.exports